import React, { useState } from "react";
import { Col, Form, Input, message, Row } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { _contactUs } from "../../../components/https/contact-us";
import { errorRequestHandel } from "../../../helper";
import CustomPrimaryButton from "../../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";
import CustomCard from "../../../dentail-indetifcation/components/d-reusable/CustomCard";

const AgeAssessmentSupport = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await _contactUs(values);
      if (response.status === 200) {
        message.success("Your request has been submitted successsfully");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };
  return (
    <div className="support_screen_container">
      <CustomCard>
        <div className="support_screen_body">
          <p className="_heading">Send us a Messsage</p>
          <br />
          <Form layout="vertical" onFinish={onFinish}>
            <Row gutter={[20, 0]}>
              <Col md={8}>
                <Form.Item
                  label="Full Name"
                  name="name"
                  rules={[
                    { required: true, message: "This field is required" },
                  ]}
                >
                  <Input placeholder="First Name" />
                </Form.Item>
              </Col>
              <Col md={8}>
                <Form.Item
                  label="Mobile Number"
                  name="mobile_no"
                  rules={[
                    { required: true, message: "This field is required" },
                  ]}
                >
                  <Input placeholder="Mobile Number" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[20, 0]}>
              <Col md={16}>
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "This field is required" },
                  ]}
                >
                  <Input placeholder="Email Address" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[20, 0]}>
              <Col md={16}>
                <Form.Item
                  label="Message"
                  name="message"
                  rules={[
                    { required: true, message: "This field is required" },
                  ]}
                >
                  <Input.TextArea
                    style={{ minHeight: 100 }}
                    placeholder="Write a message..."
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* <Row gutter={[20, 0]}>
              <Col md={16}>
                <Form.Item label={false}>
                  <ReCAPTCHA
                    sitekey="Your client site key"
                    // onChange={onChange}
                  />
                </Form.Item>
              </Col>
            </Row> */}
            <Row gutter={[20, 0]}>
              <Col md={16}>
                <CustomPrimaryButton
                  title="Send"
                  type={"submit"}
                  isLoading={loading}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </CustomCard>
    </div>
  );
};

export default AgeAssessmentSupport;
